import React, {useState, useRef} from 'react'
import { getFileName } from '../../../helpers/FileCaching';
import WorldNews from '../../App/WorldNews/WorldNews';
import classes from './Introduction.module.scss'
import globalJSON from 'data/global.json'
import VideoCarousel from './VideoCarousel';
import Modal from './Modal'
import MoreInSeries from './VideoCarousel/MoreInSeries';

const introductionImages = require.context('../../../images/components/Introduction', true, /.*\.(gif|png|jpe?g|svg)$/i);

function Introduction(props){

	const [isModalVisible, setIsModalVisible] = useState(false);
	const [modalSelectionIndex, setSelectionIndex] = useState(0);

	let modalVideos = [...props.content.carouselVideos, ...props.content.moreInSeries.episodes]

	function onModalSelect(index){
		let modalVideoIndex = props.content.carouselVideos.length + index
		setSelectionIndex(modalVideoIndex);
		trackModalChoice(modalVideoIndex)
		setIsModalVisible(true);
		
	}

	function onCarouselSelect(index){
		setSelectionIndex(index);
		trackModalChoice(index)
		setIsModalVisible(true);
	}

	function trackModalChoice(index){
		
		let chosenVideo = modalVideos[index].video[0]

		window.gtag('event', "Hero video modal", {
			'event_category': globalJSON.tracking.ga_category,
			'event_label': chosenVideo.thumbnail.caption + " chosen",
			'value':10
		});

	}

	function onContentComplete(){

	}

	return (
		<section id={"introduction"} className={classes.introduction}>
			<div className={classes.introduction__container}>
				<div className={classes.introduction__world_news_wrapper}>
					<WorldNews content={globalJSON.globalAiringTimes}/>
				</div>
				
				<div className={classes.introduction__carousel_container} >
					<div className={classes.introduction__logo}
						style={
							{
							backgroundImage: 'url(' + getFileName(introductionImages, props.content.logo) + ')'
							}										
						}
						title="Follow the food"
					></div>
					<VideoCarousel onItemSelection={(forIndex) =>{onCarouselSelect(forIndex)}} content={props.content.carouselVideos}/>
					<MoreInSeries onItemSelection={(forIndex) =>{onModalSelect(forIndex)}} content={props.content.moreInSeries}/>
				</div>
				<Modal 
					onContentComplete={onContentComplete} 
					videos={modalVideos}
					videoSelectionIndex={modalSelectionIndex}
					onClose={() => {setIsModalVisible(false)}} 
					show={isModalVisible}/>
			</div>
		</section>
		
	)
}

export default Introduction